window.el = {};
window.el.equalProductNameHeight = () => {
    let cacheHeight = 0;
    let productNameEle = document.querySelectorAll('.grid-item__meta-main');
    productNameEle.forEach(name => {
        let eleHeight = name.clientHeight;
        (eleHeight > cacheHeight) ? cacheHeight = eleHeight: cacheHeight = cacheHeight;
    })
    cacheHeight = cacheHeight + 1
    productNameEle.forEach(name => {
      name.style.height = `${cacheHeight}px`
    })
}

window.addEventListener('DOMContentLoaded', () => {
  window.el.equalProductNameHeight();
})

$('.collection-filter_tab').click(function(){
  $('.grid__item--sidebar').addClass('active');
});

$('.close-filter-dk').click(function(){
  $('.grid__item--sidebar').removeClass('active');
});

$(document).on('mouseup', function(e) {
  let sidebar = $('.collection-content .grid__item--sidebar.active');
  if(!sidebar.is(e.target) && $(sidebar).has(e.target).length === 0) {
    $(sidebar).removeClass('active');
  }
})

// Hide Header on scroll down
  var didScroll;
  var lastScrollTop = 0;
  var delta = 5;
  var navbarHeight = $('header').outerHeight();
  
  $(window).scroll(function(event){
      didScroll = true;
  });
  
  setInterval(function() {
      if (didScroll) {
          hasScrolled();
          didScroll = false;
      }
  }, 250);
  
  function hasScrolled() {
      var st = $(this).scrollTop();
  
      if(Math.abs(lastScrollTop - st) <= delta)
          return;
  
      if (st <= 300) {
          $('header').removeClass('nav-down nav-up');
          $('.collection-filter').removeClass('nav-up');
      } else if (st > lastScrollTop && st > navbarHeight) {
          $('header').removeClass('nav-down').addClass('nav-up');
          $('.collection-filter').addClass('nav-up');
      } else {
          if(st + $(window).height() < $(document).height()) {
              $('header').removeClass('nav-up').addClass('nav-down');
              $('.collection-filter').removeClass('nav-up');
          }
      }
  
      lastScrollTop = st;
  }

  setInterval(function() {
    $('.cart__item').each(function() {
        if ($(this).find('small.cart__discount').length) {
            $(this).addClass('has-discount');
        } else {
            $(this).removeClass('has-discount');
        }
    });
}, 500);



